import { useState } from "react";
import { NavLink, Outlet, useNavigate } from "react-router-dom";
import {
  LayoutDashboard, Users, FolderTree, BookOpen, Database, Package, Target, Timer, ClipboardList, BarChart3, Wallet, Settings, ShieldCheck, Menu, X, LogOut, Home,
} from "lucide-react";
import { Logo } from "@/components/Brand";
import { useAuth } from "@/context/AuthContext";

export const MENU = [
  { to: "/admin", label: "Ringkasan", icon: LayoutDashboard, end: true, id: "overview" },
  { to: "/admin/peserta", label: "Manajemen Peserta", icon: Users, id: "users" },
  { to: "/admin/kategori", label: "Manajemen Kategori", icon: FolderTree, id: "categories" },
  { to: "/admin/materi", label: "Manajemen Materi", icon: BookOpen, id: "subjects" },
  { to: "/admin/bank-soal", label: "Bank Soal", icon: Database, id: "questions" },
  { to: "/admin/paket", label: "Paket Tryout", icon: Package, id: "packages" },
  { to: "/admin/passing-grade", label: "Passing Grade", icon: Target, id: "passing-grade" },
  { to: "/admin/pengaturan-ujian", label: "Timer & Pengaturan Ujian", icon: Timer, id: "exam-settings" },
  { to: "/admin/hasil", label: "Hasil Ujian", icon: ClipboardList, id: "results" },
  { to: "/admin/statistik", label: "Statistik Peserta", icon: BarChart3, id: "stats" },
  { to: "/admin/pembayaran", label: "Pembayaran", icon: Wallet, id: "payments" },
  { to: "/admin/pengaturan", label: "Pengaturan Website", icon: Settings, id: "settings" },
  { to: "/admin/admin", label: "Admin & Hak Akses", icon: ShieldCheck, id: "admins" },
];

const Side = ({ onNav }) => {
  const { logout } = useAuth();
  const nav = useNavigate();
  return (
    <div className="flex h-full flex-col">
      <div className="px-5 py-5"><Logo light to="/admin" /></div>
      <nav className="flex-1 space-y-0.5 overflow-y-auto px-3 pb-4">
        {MENU.map((m) => (
          <NavLink key={m.to} to={m.to} end={m.end} onClick={onNav} data-testid={`admin-menu-${m.id}`}
            className={({ isActive }) => `flex items-center gap-3 rounded-lg px-3 py-2.5 text-sm font-medium transition-colors ${isActive ? "bg-amber-400/15 text-amber-300" : "text-slate-300 hover:bg-white/5 hover:text-white"}`}>
            <m.icon className="h-4 w-4 shrink-0" />{m.label}
          </NavLink>
        ))}
      </nav>
      <div className="space-y-1 border-t border-white/10 p-3">
        <button onClick={() => nav("/")} className="flex w-full items-center gap-3 rounded-lg px-3 py-2 text-sm text-slate-300 hover:bg-white/5" data-testid="admin-to-site"><Home className="h-4 w-4" />Lihat Website</button>
        <button onClick={() => { logout(); nav("/"); }} className="flex w-full items-center gap-3 rounded-lg px-3 py-2 text-sm text-red-300 hover:bg-white/5" data-testid="admin-logout"><LogOut className="h-4 w-4" />Keluar</button>
      </div>
    </div>
  );
};

export default function AdminLayout() {
  const [open, setOpen] = useState(false);
  const { user } = useAuth();
  return (
    <div className="flex min-h-screen bg-slate-50">
      <aside className="sticky top-0 hidden h-screen w-64 shrink-0 bg-[#0A192F] lg:block"><Side /></aside>
      {open && (
        <div className="fixed inset-0 z-50 lg:hidden">
          <div className="absolute inset-0 bg-black/50" onClick={() => setOpen(false)} />
          <aside className="relative h-full w-72 bg-[#0A192F]"><button className="absolute right-3 top-5 text-white" onClick={() => setOpen(false)} data-testid="admin-sidebar-close"><X className="h-5 w-5" /></button><Side onNav={() => setOpen(false)} /></aside>
        </div>
      )}
      <div className="min-w-0 flex-1">
        <header className="sticky top-0 z-30 flex h-14 items-center justify-between border-b bg-white/90 px-4 backdrop-blur sm:px-8">
          <button className="lg:hidden" onClick={() => setOpen(true)} data-testid="admin-sidebar-open"><Menu className="h-5 w-5" /></button>
          <span className="text-sm font-bold tracking-widest text-[#0A192F]">DASHBOARD ADMIN</span>
          <span className="truncate text-sm text-slate-500" data-testid="admin-user-name">{user?.name}</span>
        </header>
        <main className="p-4 sm:p-8"><Outlet /></main>
      </div>
    </div>
  );
}

export const PageTitle = ({ title, desc, children }) => (
  <div className="mb-6 flex flex-wrap items-end justify-between gap-4">
    <div>
      <h1 className="font-display text-2xl font-extrabold text-[#0A192F] sm:text-3xl" data-testid="admin-page-title">{title}</h1>
      {desc && <p className="mt-1 text-sm text-slate-500">{desc}</p>}
    </div>
    <div className="flex flex-wrap gap-2">{children}</div>
  </div>
);

export const GoldBtn = ({ children, className = "", ...p }) => (
  <button className={`btn-gold inline-flex items-center gap-2 rounded-lg px-4 py-2 text-sm disabled:opacity-60 ${className}`} {...p}>{children}</button>
);
